<template>
  <div class="admin-page p-3">
    <PageTitle main="Administração" />
    <div class="admin-pages-tabs">
      <b-card no-body>
        <b-tabs card>
          <b-tab title="Artigo" active>
            <ArticleAdmin />
          </b-tab>
          <b-tab title="Categoria">
            <CategoryAdmin />
          </b-tab>
          <b-tab title="Comentário">
            <CommentAdmin />
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import PageTitle from "../template/PageTitle.vue";
import ArticleAdmin from "./ArticleAdmin.vue";
import CategoryAdmin from "./CategoryAdmin.vue";
import CommentAdmin from "./CommentAdmin.vue";

export default {
  name: "AdminPages",
  components: { PageTitle, ArticleAdmin, CategoryAdmin, CommentAdmin },
  mounted() {
    this.$store.commit("toggleFooter", false);
    this.$store.commit("toggleMenu", false);
  },
};
</script>
